import { jsx } from "react/jsx-runtime";
import PestControlRodentOutlinedIcon from "@mui/icons-material/PestControlRodentOutlined";
import { validateTidalLicense } from "../../base/index.js";
function PestControlRodentOutlined(props) {
  return /* @__PURE__ */ jsx(
    PestControlRodentOutlinedIcon,
    {
      "data-testid": "PestControlRodentOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PestControlRodentOutlined",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
PestControlRodentOutlined.tidalIconMeta = {
  categories: "miscellaneous",
  name: "PestControlRodentOutlined"
};
validateTidalLicense();
export {
  PestControlRodentOutlined
};
//# sourceMappingURL=PestControlRodentOutlined.js.map
